import { Box, Button, List, ListItem } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Slide from '@material-ui/core/Slide';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Zoom from '@material-ui/core/Zoom';
import makeStyles from '@material-ui/styles/makeStyles';
import { useSnackbar } from 'notistack';
import React from 'react';
import FirebaseAuth from 'react-firebaseui/FirebaseAuth';
import { useHistory } from 'react-router';

import { Collections } from 'Collections';
import { auth, uiConfig } from 'FirebaseConfigs';
import { FirebaseUtils } from 'firebaseUtils/FirebaseUtils';
import { AnalyticsEvent } from 'models/AnalyticsEvent';
import { AppUser } from 'models/AppUser';
import { EnqueueSnacbar } from 'models/EnqueueSnacbar';
import { Paths } from 'Paths';
import { createOrg, importAllIndustryTemplates } from 'screens/SelectOrgScreen';

import { useOrgIdLocalStorage } from './OrgProvider';
import { IndustryTypes } from 'models/IndustryTypes';

const useStyles = makeStyles((theme: Theme) => ({
    content: {
        height: '100vh',
        display: 'grid',
        placeItems: 'center',
    },
    innerContainer: {
        display: 'grid',
        placeItems: 'center',
    },
    logo: {
        height: 100,
        marginBottom: theme.spacing(3),
    },
}))

async function createAnonymousUser(enqueueSnackbar: EnqueueSnacbar, history: ReturnType<typeof useHistory>, setOrgId: (orgId: string) => void) {
    const authUser = await auth.signInAnonymously()
    if (authUser.user) {
        const uid = authUser.user.uid
        const appUser: AppUser = {
            id: uid,
            contactInfo: null,
            avatarImage: null,
            appRoles: {
                map: {},
            },
        }
        FirebaseUtils.createDocument<AppUser>(
            true,
            Collections.APP_USERS,
            uid,
            null,
            null,
            AnalyticsEvent.CREATED_APP_USER,
            AnalyticsEvent.CREATED_APP_USER,
            AnalyticsEvent.CREATE_APP_USER_ERROR,
            enqueueSnackbar,
            'Anonym App Bruker opprettet',
            appUser,
            (doc) => ({
                authUserId: uid,
                appUserId: doc.id,
            }),
            async () => {
                const industryTypes = {
                    [IndustryTypes.FlatEnum.ELECTRICAL]: true,
                }
                const orgId = await createOrg(appUser, null, null, null, { map: industryTypes }, enqueueSnackbar, true)
                importAllIndustryTemplates(orgId, appUser, industryTypes, enqueueSnackbar)
                setOrgId(orgId)
                history.push(Paths.DASHBOARD)
            }
        )
    }
}

export function SignIn() {
    const classes = useStyles();
    const { enqueueSnackbar } = useSnackbar()
    const history = useHistory()
    const [, setOrgId] = useOrgIdLocalStorage()
    return (
        <div>
            <AppBar position="fixed">
                <Toolbar>
                    <Typography variant="h6" color="inherit" noWrap>TrygKalk</Typography>
                </Toolbar>
            </AppBar>
            <main className={classes.content}>
                <div className={classes.innerContainer}>
                    <Slide direction="down" in mountOnEnter unmountOnExit timeout={1000}>
                        <img className={classes.logo} src="/icons/logo.svg" alt="logo" />
                    </Slide>
                    <Zoom in timeout={1000}>
                        <div>
                            <List>
                                <ListItem disableGutters>
                                    <Box px="24px" width="100%" mb="-15px">
                                        <Button
                                            fullWidth
                                            color="primary"
                                            variant="contained"
                                            onClick={() => createAnonymousUser(enqueueSnackbar, history, setOrgId)}
                                        >Jeg bare kikker</Button>
                                    </Box>
                                </ListItem>
                                <ListItem disableGutters>
                                    <FirebaseAuth uiConfig={uiConfig} firebaseAuth={auth} />
                                </ListItem>
                            </List>
                        </div>
                    </Zoom>
                </div>
            </main>
        </div>
    );
}
